export const environment = {
  production: true,
  environment: 'PROD',
  apiServerUrl: '',
  cbolUrl: 'https://online.citi.com',
  locale: 'en_US',
  businessId: 'USMKT',
  crossSiteScriptingRegex: '',
  csrHostName: "https://online.citi.com",
  newCitiHostName: 'https://online.citi.com',
  acqHostName: 'https://online.citi.com',
  apiServerUrlPlatformClient: '',
  apiServerUrlPlatformServer: '',
  partnerId: '',
  isFeatureEntitlementEnabled: true,
  newLogicBranding: true,
  mergeSSRCSR: true,
  newSessionDeleteLogic: true,
  CBOL_SESSION_LEGACY_FALLBACK: false,
  QATOOL_URL: '/prelogin/digital/creditCards/offers/qatool',
  cardsmkrHostName: '',
  CBOL_URL: '',
  CBOL_NGA_URL: '',
  CBOL_SSR_URL: '',
  CERTIFICATE_FILE: '',
  DYNAMIC_PRICING_ENDPOINT1_URL: '',
  DYNAMIC_PRICING_ENDPOINT2_URL: '',
  CBOL_CLIENT_ID: '',
  BANNER_CLIENT_URL: '',
  BANNER_CLIENT_ID: '',
  APPLY_NOW_BASE_URL: '',
  DISPLAY_TERMS_BASE_URL: '',
  ACQ_BASE_URL: '',
  PRE_QUAL_URL: '',
  APP_STATUS_BASE_URL: '',
  APPLY_NOW_MBOL_BASE_URL: '',
  APP_VERSION: '',
  IP_ADDRESS: '',
  sessionCookieInformation: {

    cookieName: 'NGACoExistenceCookie',
    valueSeparator: '|',
    headers: [
      {
        headerName: 'bizToken',
        headerValue: '[bizToken]'
      },
      {
        headerName: 'Authorization',
        headerValue: 'Bearer [authToken]'
      },
      {
        headerName: 'client_id',
        headerValue: '[clientId]'
      }
    ],
    isFriendKey: 'isFriend'
  },
  contentService: {
    staticBaseUrl: '',
    defaultHeaders:
    {
      'Content-Type': 'application/json',
      'client_id': '',
      'businessCode': 'GCB',
      'countryCode': 'US',
      'channelId': 'CBOL',
      'Accept': 'application/json'
    }
  },
  httpService: {
    defaultHeaders:
    {
      'Content-Type': 'application/json',
      'client_id': '',
      'businessCode': 'GCB',
      'countryCode': 'US',
      'channelId': 'CBOL',
      'Accept': 'application/json'
    },
    headersToSendFromPreviousResponse: [
      {
        headerNameInPreviousResponse: 'CCPToken',
        headerNameToSendInRequest: 'CCPToken'
      },
      {
        headerNameInPreviousResponse: 'bizToken',
        headerNameToSendInRequest: 'bizToken',
        deleteOnAppLoad: true
      }
    ],
    headersToSendFromPreviousResponsenewlogic: [
      {
        headerNameInPreviousResponse: 'CCPToken',
        headerNameToSendInRequest: 'CCPToken'
      }
    ],
    headersToSaveFromResponse: [
      'eventid'
    ]
  },
  customConfig: {
    errorUrl: '/US/JPS/portal/Unauthorized.do',
    staticAssetsUrl: '/credit-cards/',
    brandingApiUrl: 'https://online.citi.com',
    brandingEndpoint: '/CBOL/IA/Angular/Branding'
  },
  sessionService: {
    sessionTimeout: 600,
    keepAliveInterval: 180,
    sessionKeepAliveUrl: '',
    sessionTimeoutUrl: '',
    preLoginTimeout: 180
  },
  sessionIdentifiers: [
    {
      sessionType: 'legacy',
      cookieNames: [
        {
          cookieName: 'NGACoExistenceCookie',
          valueSeparator: '|'
        }
      ]
    },
    {
      sessionType: 'nga',
      cookieNames: [
        {
          cookieName: 'isLoggedIn'
        }
      ]
    }
  ],
  citiSessionService: {
    sessionTimeout: 600,
    keepAliveInterval: 180,
    sessionTimeoutUrl: '',
    cookieName: 'NGACoExistenceCookie',
    sessions: [
      {
        sessionKeepAliveUrl: '',
        sessionTimeoutUrl: '',
        sessionMethod: 'GET',
        sessionType: 'token'
      },
      {
        sessionKeepAliveUrl: '',
        sessionTimeoutUrl: '',
        sessionMethod: 'GET',
        sessionType: 'cookie'
      },
      {
        sessionKeepAliveUrl: '',
        sessionTimeoutUrl: '',
        sessionMethod: 'POST',
        sessionType: 'token'
      },
      {
        sessionKeepAliveUrl: '',
        sessionTimeoutUrl: '',
        sessionMethod: 'POST',
        sessionType: 'cookie'
      }
    ]
  },
  aemConfig: {
    aemServerUrl: '',
    aemStaticAssetsUrl: '',
    aemContentServiceUrl: '',
    aemContentServiceHeaders: {}
  }
}
